import { captureException } from "@sentry/react-native"

import { logger } from "./logger"

export function handleError(error: unknown) {
  logger.error(error)
  captureException(error)
}
